<template>
  <div />
</template>

<script>
import { FRONTEND_V2 } from '@/config';

export default {
  name: 'LoginRedirect',
  created() {
    const next = this.$route.query.next || this.$route.query.callbackUrl || '/home/main';
    const path = next.startsWith('http') ? next : `${window.location.origin}${next.startsWith('/') ? next : `/${next}`}`;
    window.location.href = `${FRONTEND_V2}/login?callbackUrl=${encodeURIComponent(path)}`;
  },
};
</script>
